// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"collapsible-block"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M4 3L6 5L8 3H4Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M19 5L17 3L15 5L19 5Z"}}]},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M4 3L6 5L8 3H4Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M19 5L17 3L15 5L19 5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 11H13M3 16H21M3 21H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CollapsibleBlockIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'collapsible-block',
    ref,
    icon: element,
  },
));

CollapsibleBlockIcon.displayName = 'CollapsibleBlockIcon';

export default CollapsibleBlockIcon;
